import { formatWrittenDate } from '_/utils/dateUtils';
import zeusSdk from '_/utils/SDKs';

export interface Integration {
  id: string;
  name: string;
  addedAt: string;
  [key: string]: any;
}

export interface FormattedIntegration extends Integration {
  href: string;
  createdOn: string;
  linkSupported: boolean;
}

export const fetchIntegrations = async (orgSlug: string): Promise<FormattedIntegration[]> => {
  try {
    const options = {
      queryParameters: {
        sort: 'name',
        sortDirection: 'ASC',
      },
    };

    const integrations = await zeusSdk.integrations.listAll(options);

    return integrations.map((integration: Integration) => ({
      ...integration,
      href: `/orgs/${orgSlug}/integrations/${integration.id}/edit`,
      createdOn: formatWrittenDate(integration.addedAt),
      linkSupported: true,
    }));
  } catch (error) {
    console.error('Error fetching integrations', error);
    return [];
  }
};

export const createIntegration = async (integration: Partial<Integration>): Promise<Integration> => {
  return zeusSdk.integrations.create(integration);
};

export const updateIntegration = async (integrationId: string, updates: Partial<Integration>): Promise<Integration> => {
  return zeusSdk.integrations.patch(integrationId, updates);
};

export const deleteIntegration = async (integrationId: string): Promise<void> => {
  await zeusSdk.integrations.delete(integrationId);
};
